module.exports = __webpack_public_path__ + "img/main_cha.8ec453df.svg";